// Moteur cosmétique (code pur partagé) -- Types du formulateur cosmetique (code pur, partage client/serveur).
//
// Modele metier porte depuis le formulateur d'origine (BD-SapoPro V1) (composant FormulateurCosmetique),
// reecrit en TypeScript strict. Aucune dependance UI / localStorage / DB ici :
// uniquement des types et des fonctions pures (testables sous vitest).

export type FamilleClef = "EMULSION" | "SERUM" | "GEL" | "BAUME";

export type PhaseId =
  | "phase_aqueuse"
  | "phase_huileuse"
  | "emulsifiant"
  | "actifs"
  | "conservateurs"
  | "parfum";

/** Ordre reglementaire / d'affichage des phases d'une formule. */
export const PHASES_ORDRE: readonly PhaseId[] = [
  "phase_aqueuse",
  "phase_huileuse",
  "emulsifiant",
  "actifs",
  "conservateurs",
  "parfum",
] as const;

/** Une ligne de formule : un ingredient et son pourcentage dans le produit fini. */
export interface LigneFormule {
  /** Nom natif ou INCI de l'ingredient. */
  nom: string;
  /** Pourcentage (% du poids total du produit fini). */
  pourcentage: number;
  /** Prix au kilo (euros), optionnel, pour le calcul de cout. */
  prix_kg?: number;
}

/** Formule complete : poids total (g) + lignes par phase + drapeaux reglementaires. */
export interface FormuleCosmetique {
  /** Type de produit (ex. "Creme visage"), rattache a une famille. */
  type_produit: string;
  /** Poids total du batch en grammes (base de conversion % -> g). */
  poids_total: number;
  phase_aqueuse: LigneFormule[];
  phase_huileuse: LigneFormule[];
  emulsifiant: LigneFormule[];
  actifs: LigneFormule[];
  conservateurs: LigneFormule[];
  parfum: LigneFormule[];
  /** Produit destine aux enfants de moins de 3 ans (restrictions renforcees). */
  destine_enfants?: boolean;
  /** Produit a rincer (seuils allergenes/dosages differents). */
  a_rincer?: boolean;
}

export type NiveauAlerte = "danger" | "warning" | "success" | "info";

/** Alerte de controle (reglementaire, dosage, formulation). */
export interface Alerte {
  type: NiveauAlerte;
  message: string;
}
